import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AdminSetting from "./pages/admin_setting/AdminSettingsPage";
import NewBotCreation from "./pages/admin_setting/NewBotCreation";
import ChatBotEdit from "./pages/admin_setting/ChatBotEdit";
import UserView from "./pages/admin_setting/Userview";
import ChatPagePreDef from "./pages/chat_page/ChatPagePreDef";
import HelpQuestions from "./components/layout/topbar/help/help";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ChatPagePreDef />} />
        <Route path="/admin_setting" element={<AdminSetting />} />
        <Route path="/bot_creation" element={<NewBotCreation />} />
        <Route path="/chat_bot_edit" element={<ChatBotEdit />} />
        <Route path="/user_view" element={<UserView />} />
        <Route path="/help" element={<HelpQuestions />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        className="font-bold"
      />
    </Router>
  );
}

export default App;
